// extracted by mini-css-extract-plugin
export default {"nameCell":"RagfM","name":"sfuR_","nameCaption":"nWDao","statusCell":"DNoeo","schoolCell":"CZPng"};